export function getdata() {
	var obj = {
		headDataI: [{
				title: "操作",
				prop: "cz",
				width: "150px",
				custom: true,
			},
			{
				title: "应税消费品名称",
				prop: "xfs_1_x_0",
				width: "150px",
				custom: true,
			},
			{
				title: "一、本期准予扣除的委托加工应税消费品已纳税款计算",
				children: [{
						title: "期初库存委托加工应税消费品已纳税款",
						prop: "xfs_1_x_1",
						width: "150px",
						custom: true,
					},
					{
						title: "本期收回委托加工应税消费品已纳税款",
						prop: "xfs_1_x_2",
						width: "150px",
						custom: true,
					},
					{
						title: "期末库存委托加工应税消费品已纳税款",
						prop: "xfs_1_x_3",
						width: "150px",
						custom: true,
					},
					{
						title: "本期领用不准予扣除委托加工应税消费品已纳税款",
						prop: "xfs_1_x_4",
						width: "150px",
						custom: true,
					},
					{
						title: "本期准予扣除委托加工应税消费品已纳税款",
						prop: "xfs_1_x_5",
						width: "150px",
						custom: true,
					},
				]
			}, {
				title: "二、本期准予扣除的外购应税消费品已纳税款计算",
				children: [{
						title: "（一）从价计税",
						children: [{
							title: "期初库存外购应税消费品买价",
							prop: "xfs_1_x_6",
							width: "150px",
							custom: true,
						}, {
							title: "本期购进应税消费品买价",
							prop: "xfs_1_x_7",
							width: "150px",
							custom: true,
						}, {
							title: "期末库存外购应税消费品买价",
							prop: "xfs_1_x_8",
							width: "150px",
							custom: true,
						}, {
							title: "本期领用不准予扣除外购应税消费品买价",
							prop: "xfs_1_x_9",
							width: "150px",
							custom: true,
						}, {
							title: "适用税率",
							prop: "xfs_1_x_10",
							width: "150px",
							custom: true,
						}, {
							title: "本期准予扣除外购应税消费品已纳税款",
							prop: "xfs_1_x_11",
							width: "150px",
							custom: true,
						}, ]
					},
					{
						title: "（二）从量计税",
						children: [{
							title: "期初库存外购应税消费品数量",
							prop: "xfs_1_x_12",
							width: "150px",
							custom: true,
						}, {
							title: "本期外购应税消费品数量",
							prop: "xfs_1_x_13",
							width: "150px",
							custom: true,
						}, {
							title: "期末库存外购应税消费品数量",
							prop: "xfs_1_x_14",
							width: "150px",
							custom: true,
						}, {
							title: "本期领用不准予扣除外购应税消费品数量",
							prop: "xfs_1_x_15",
							width: "150px",
							custom: true,
						}, {
							title: "适用税率",
							prop: "xfs_1_x_16",
							width: "150px",
							custom: true,
						}, {
							title: "计量单位",
							prop: "xfs_1_x_17",
							width: "150px",
							custom: true,
						}, {
							title: "本期准予扣除的外购应税消费品已纳税款",
							prop: "xfs_1_x_18",
							width: "150px",
							custom: true,
						}, ]
					}
				]
			},
			{
				title: "三、本期准予扣除税款合计",
				prop: "xfs_1_x_19",
				width: "150px",
				custom: true,
			},
		],

		tableDataI: [{
			disablednoty_0_x_tes1: false,
			disablednoty_0_x_tes2: false,
			disablednoty_0_x_tes3: false,
			disablednoty_0_x_tes4: false,
			disablednoty_0_x_tes5: false,
			disablednoty_0_x_tes6: false,
			disablednoty_0_x_tes7: false,
			disablednoty_0_x_tes8: false,
			disablednoty_0_x_tes9: false,
			disablednoty_0_x_tes10: false,
			disablednoty_0_x_tes11: false,
			disablednoty_0_x_tes12: false,
			disablednoty_0_x_tes13: false,
			disablednoty_0_x_tes14: false,
			disablednoty_0_x_tes15: false,
			disablednoty_0_x_tes16: false,
			disablednoty_0_x_tes17: false,
			disablednoty_0_x_tes18: false,
			disablednoty_0_x_tes19: false,
			disablednoty_0_x_tes20: false,
			tes1: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes2: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes3: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes4: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes5: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes6: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes7: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes8: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes9: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes10: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes11: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes12: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes13: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes14: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes15: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes16: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes17: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes18: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes19: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes20: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
		}, {
			disablednoty_0_x_tes1: false,
			disablednoty_0_x_tes2: false,
			disablednoty_0_x_tes3: false,
			disablednoty_0_x_tes4: false,
			disablednoty_0_x_tes5: false,
			disablednoty_0_x_tes6: false,
			disablednoty_0_x_tes7: false,
			disablednoty_0_x_tes8: false,
			disablednoty_0_x_tes9: false,
			disablednoty_0_x_tes10: false,
			disablednoty_0_x_tes11: false,
			disablednoty_0_x_tes12: false,
			disablednoty_0_x_tes13: false,
			disablednoty_0_x_tes14: false,
			disablednoty_0_x_tes15: false,
			disablednoty_0_x_tes16: false,
			disablednoty_0_x_tes17: false,
			disablednoty_0_x_tes18: false,
			disablednoty_0_x_tes19: false,
			disablednoty_0_x_tes20: false,
			tes1: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes2: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes3: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes4: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes5: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes6: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes7: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes8: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes9: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes10: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes11: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes12: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes13: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes14: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes15: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes16: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes17: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes18: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes19: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes20: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
		}, {
			disablednoty_0_x_tes1: false,
			disablednoty_0_x_tes2: false,
			disablednoty_0_x_tes3: false,
			disablednoty_0_x_tes4: false,
			disablednoty_0_x_tes5: false,
			disablednoty_0_x_tes6: false,
			disablednoty_0_x_tes7: false,
			disablednoty_0_x_tes8: false,
			disablednoty_0_x_tes9: false,
			disablednoty_0_x_tes10: false,
			disablednoty_0_x_tes11: false,
			disablednoty_0_x_tes12: false,
			disablednoty_0_x_tes13: false,
			disablednoty_0_x_tes14: false,
			disablednoty_0_x_tes15: false,
			disablednoty_0_x_tes16: false,
			disablednoty_0_x_tes17: false,
			disablednoty_0_x_tes18: false,
			disablednoty_0_x_tes19: false,
			disablednoty_0_x_tes20: false,
			tes1: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes2: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes3: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes4: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes5: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes6: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes7: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes8: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes9: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes10: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes11: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes12: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes13: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes14: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes15: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes16: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes17: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes18: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes19: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
			tes20: {
				cellCode: "ty_0_x_1",
				cellType: "1",
				cellVal: "0.00"
			},
		}, ],
	}
	return obj
}